import _isEmpty from 'lodash/isEmpty';
import getCart from '@/api/get/cart';
import updateCartEntry from '@/api/post/updateCartEntry';
import { pushAccessoryRemove } from '@/utils/Controllers/GTM/Operations/Kenwood/Configurator';

export const handleRemoveProduct = ({
  productCode,
  cartEntries,
  setCartEntries,
  setCartData,
  setIsRemovingFromCart,
  isOwner,
  categoryName,
  productName,
}) => {
  setIsRemovingFromCart(true);
  updateCartEntry({
    entryNumber: cartEntries.find(entry => entry.productCode === productCode)
      .entryNumber,
    quantity: 0,
    successCB: () => {
      pushAccessoryRemove(isOwner, categoryName, productName);
      getCart({
        successCB: data => {
          setCartEntries(data?.entries || []);
          setCartData(data);
          setIsRemovingFromCart(false);
        },
        failCB: () => {
          setIsRemovingFromCart(false);
        },
      });
    },
    failCB: () => {
      setIsRemovingFromCart(false);
    },
  });
};

export const handleRemoveConnection = ({
  isOwner,
  selectedCategory,
  selectedConnection,
  setSelectedConnection,
  setCartEntries,
  setCartData,
}) => {
  // In case the user lands on step 2 after adding a connection
  // The connection is always the first entry in the cart
  updateCartEntry({
    entryNumber: 0,
    quantity: 0,
    successCB: () => {
      pushAccessoryRemove(
        isOwner,
        selectedCategory.name,
        selectedConnection.name,
      );
      setSelectedConnection(null);
      // Since we removed the connection we need to update the cart entries
      getCart({
        successCB: data => {
          setCartEntries(data?.entries || []);
          setCartData(data);
        },
      });
    },
  });
};

export const calculateTotals = cartData => {
  if (!cartData) {
    return {};
  }

  const dstfv = cartData.dlgSubtotal?.formattedValue;
  const dstv = cartData.dlgSubtotal?.value;
  const stfv = cartData.subTotal?.formattedValue;
  const stv = cartData.subTotal?.value;

  if (dstv !== stv) {
    return {
      promoMessage: cartData.cartCouponPromotionMessage,
      dlgSubtotal: dstfv,
      subTotal: stfv,
      differentTotals: dstv !== stv,
    };
  }

  const dstvCalculated =
    Math.round(
      cartData.entries.reduce(
        (total, entry) =>
          total + entry.strikethroughPriceValue * entry.quantity,
        0,
      ) * 100,
    ) / 100;

  return {
    promoMessage:
      cartData.cartCouponPromotionMessage ||
      cartData.entries.find(
        entry => !_isEmpty(entry.entryCouponPromotionMessage),
      )?.entryCouponPromotionMessage,
    dlgSubtotal: dstvCalculated
      .toLocaleString(undefined, { minimumFractionDigits: 2 })
      .replaceAll(/,/g, '.')
      .replace(/\.(?=[^.]*$)/, ','),
    subTotal: stfv,
    differentTotals: dstvCalculated !== stv,
  };
};
